import {
  ToggleButton as MuiToggleButton,
  ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material'
import styled from 'styled-components'

export type ToggleButtonPropsType = MuiToggleButtonProps

const ToggleButton = styled(MuiToggleButton)<ToggleButtonPropsType>``

export default ToggleButton
